import {
	Archive,
	Barcode,
	Building,
	Calendar,
	Categories,
	CollectOut,
	Contacts,
	Database,
	Depreciation,
	DotsHorizontal,
	Email,
	FlagAlt,
	Items,
	Kits,
	LinkExternal,
	LockClosed,
	Marker,
	Number,
	Phone,
	Qr,
	Reservation,
	RfidIcon,
	RoundedSquare,
	Tag,
	Tools,
	User,
	UserCheck,
	UserEdit,
	UserKey,
} from '@cheqroom/icons';

import type { FieldIconResolver } from '../Fields.types';

const getSystemFieldIcon = (id: string) => {
	switch (id) {
		case 'barcodes':
			return Barcode;
		case 'codes':
			return Qr;
		case 'rfidcodes':
			return RfidIcon;
		case 'purchaseDate':
		case 'warrantyDate':
		case 'created':
		case 'modified':
			return Calendar;
		case 'address':
			return Marker;
		case 'location':
			return undefined; // ItemInfo.Location resolves its own location-specific icon
		case 'purchasePrice':
		case 'residualValue':
			return Depreciation;
		case 'flag':
			return FlagAlt;
		case 'contact':
		case 'custody':
			return Contacts;
		case 'category':
			return Categories;
		case 'kit':
			return Kits;
		case 'retired':
			return Archive;
		case 'brand':
		case 'model':
			return RoundedSquare;
		case 'quantity':
			return Number;
		case 'itemTypeId':
		case 'user.userSync.name':
			return Database;
		case 'user.userRole.name':
			return LockClosed;
		case 'contactGroups.name':
			return Contacts;
		case 'seatType':
			return UserKey;
		case 'label':
			return Tag;
		case 'items':
			return Items;
		case 'kits':
			return Kits;
		case 'reservations':
			return Reservation;
		case 'orders':
			return CollectOut;
		case 'tickets':
			return Tools;
		case 'reporter':
			return UserEdit;
		case 'assignee':
			return UserCheck;
		default:
			return DotsHorizontal;
	}
};

/** Icon for a custom field (`fields.*`), based on its `kind`/`editor`. */
const getCustomFieldIcon = (field: Parameters<FieldIconResolver>[0]) => {
	if (field.kind === 'customer') return User;
	if (field.kind === 'location') return Building;

	switch (field.type) {
		case 'date':
		case 'datetime':
			return Calendar;
		case 'url':
			return LinkExternal;
		case 'email':
			return Email;
		case 'phone':
			return Phone;
		case 'currency':
			return Depreciation;
		case 'number':
			return Number;
		default:
			return DotsHorizontal;
	}
};

export const getIconForField: FieldIconResolver = (field) => {
	if (field.icon) return field.icon;

	if (field.id.startsWith('fields.')) return getCustomFieldIcon(field);

	return getSystemFieldIcon(field.id);
};
